<template>
  <div v-if="visible" class="modal-backdrop">
    <div class="modal-content">

      <h5 class="modal-title mb-3 text-center">
        Paiement de l'hospitalisation
      </h5>

      <div class="modal-body-scroll">

        <div class="row">

          <!-- COLONNE GAUCHE -->
          <div class="col-md-6">

            <div class="mb-3">
              <label class="form-label">Montant total</label>
              <input type="number" class="form-control" :value="totalHospitalisation" disabled />
            </div>

            <div class="mb-3">
              <label class="form-label">Total déjà payé</label>
              <input type="number" class="form-control" :value="totalDejaPaye" disabled />
            </div>

            <div class="mb-3">
              <label class="form-label">Reste à payer</label>
              <input type="number" class="form-control" :value="resteReel" disabled />
            </div>

            <div class="mb-3">
              <label class="form-label">Montant versé</label>
              <input
                type="number"
                class="form-control"
                v-model.number="montantVerse"
                :max="resteReel"
                :disabled="resteReel <= 0"
              />
            </div>

            <div class="mb-3">
              <label class="form-label">Reste après paiement</label>
              <input type="number" class="form-control" :value="resteApresPaiement" disabled />
            </div>

          </div>

          <!-- COLONNE DROITE -->
          <div class="col-md-6">

            <div class="mb-3">
              <label class="form-label">Assurance *</label>
              <select class="form-control" v-model.number="assuranceId">
                <option value="">-- Sélectionner --</option>
                <option
                  v-for="assurance in assurances"
                  :key="assurance.id"
                  :value="assurance.id"
                >
                  {{ assurance.nom }} - {{ assurance.tauxCouverture }} %
                </option>
              </select>
            </div>

            <!-- NUMERO ASSURANCE -->
            <div
              class="mb-3"
              v-if="assuranceChoisie && assuranceChoisie.tauxCouverture > 0"
            >
              <label class="form-label">Numéro assurance *</label>
              <input
                type="text"
                class="form-control"
                v-model="numeroAssurance"
                placeholder="Entrer le numéro d'assurance"
              />
            </div>

            <div class="mb-3">
              <label class="form-label">Part Assurance</label>
              <input type="number" class="form-control" :value="partAssurance" disabled />
            </div>

            <div class="mb-3">
              <label class="form-label">Part Patient</label>
              <input type="number" class="form-control" :value="partPatient" disabled />
            </div>

            <div class="mb-3">
              <label class="form-label">Mode de paiement *</label>
              <select class="form-control" v-model.number="modePaiementId">
                <option value="">-- Sélectionner --</option>
                <option
                  v-for="mode in modesPaiement"
                  :key="mode.id"
                  :value="mode.id"
                >
                  {{ mode.nom }}
                </option>
              </select>
            </div>

          </div>

        </div>

      </div>

      <!-- BOUTONS -->
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-secondary me-2" @click="close">
          Annuler
        </button>

        <button
          class="btn btn-success"
          :disabled="isLoading"
          @click="payer"
        >
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: {
    visible: Boolean,
    hospitalisation: Object,
    patientId: Number,
  },

  data() {
    return {
      isLoading: false,
      assuranceId: "",
      modePaiementId: "",
      montantVerse: 0,
      numeroAssurance: "",
      assurances: [],
      modesPaiement: [],
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters.user;
    },

    totalHospitalisation() {
      return this.hospitalisation?.montantCalcule?.montant || 0;
    },

    totalDejaPaye() {
      return this.hospitalisation?.totalEncaisse || 0;
    },

    resteReel() {
      const reste = this.totalHospitalisation - this.totalDejaPaye;
      return reste > 0 ? reste : 0;
    },

    assuranceChoisie() {
      return this.assurances.find(a => a.id === this.assuranceId) || null;
    },

    partAssurance() {
      if (!this.assuranceChoisie) return 0;
      if (this.assuranceChoisie.tauxCouverture <= 0) return 0;

      return Math.round(
        this.montantVerse * this.assuranceChoisie.tauxCouverture / 100
      );
    },

    partPatient() {
      if (!this.assuranceChoisie) return 0;

      if (this.assuranceChoisie.tauxCouverture <= 0)
        return this.montantVerse;

      return this.montantVerse - this.partAssurance;
    },

    resteApresPaiement() {
      const reste = this.resteReel - this.montantVerse;
      return reste > 0 ? reste : 0;
    },
  },

  watch: {
    assuranceId() {
      this.numeroAssurance = "";
    }
  },

  mounted() {
    this.fetchAssurances();
    this.fetchModesPaiement();
  },

  methods: {

    async fetchAssurances() {
      try {
        const res = await api.getItems("assurances");
        this.assurances = res.data.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchModesPaiement() {
      try {
        const res = await api.getItems("moyen_paiements");
        this.modesPaiement = res.data.data;
      } catch (error) {
        console.error(error);
      }
    },

    close() {
      this.$emit("fermer");
    },

    async payer() {

      if (!this.assuranceId)
        return alert("Sélectionnez une assurance.");

      if (!this.modePaiementId)
        return alert("Sélectionnez un mode de paiement.");

      if (this.montantVerse <= 0)
        return alert("Montant invalide.");

      /*if (this.montantVerse > this.resteReel)
        return alert("Le montant dépasse le reste à payer.");*/

      if (
        this.assuranceChoisie &&
        this.assuranceChoisie.tauxCouverture > 0 &&
        !this.numeroAssurance
      ) {
        return alert("Le numéro d'assurance est obligatoire.");
      }

      const payload = {
        montant: this.montantVerse,
        hospitalisation: this.hospitalisation.id,
        patient: this.patientId,
        modePaiement: this.modePaiementId,
        assurance: this.assuranceId,
        numeroAssurance: this.numeroAssurance || null,
        createdBy: this.currentUser.id,
        type: "hospitalisation",
        datePaiement: new Date().toISOString(),
      };

      this.isLoading = true;

      try {
        await api.createItem("paiement_hospitalisations", payload);
        this.$emit("paiementEffectue");
        this.close();
      } catch (error) {
        console.error(error);
        alert("Erreur lors du paiement.");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 800px;
  max-width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-body-scroll {
  overflow-y: auto;
  padding-right: 5px;
}

</style>
